import {
  GetProductGroupQuery,
  GetProductGroupQueryVariables,
  useGetProductGroupQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export const cacheKey = "GetProductGroup";

export default function useGetProductGroup({ id }: GetProductGroupQueryVariables) {
  const {
    data: graphqlData,
    loading,
    error,
    refetch,
  } = useGetProductGroupQuery({
    variables: {
      id,
    },
  });

  const getData = useCallback(
    ({ data }: { data?: GetProductGroupQuery }) => {
      return data?.getProductGroup || null;
    },
    [graphqlData]
  );

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  return {
    data,
    loading,
    error,
    getData,
    refetch,
  } as const;
}
